import { UI, HStack } from '@genial/components';
import { Color, Spacing, Typography } from '@genial/design-tokens';
import { useNavigation } from '@react-navigation/native';
import { Button } from 'native-base';
import React from 'react';

import { VisitLegacyPage } from '../../../../components/VisitLegacyPage';
import { SignedInNavigationScreenNavigationProp } from '../../../../routes/types';

interface AvailableProductsHeaderProps {
  isMobile: boolean;
  onReturn: () => void;
}

export const AvailableProductsHeader: React.FC<AvailableProductsHeaderProps> = ({
  isMobile,
  onReturn,
}) => {
  const { navigate } = useNavigation<SignedInNavigationScreenNavigationProp>();

  const onAvailableProductsLegacyPress = () =>
    navigate({
      name: 'AngularFrame_AvailableProducts',
      params: { state: 'app.produtosDisponiveis.fundosInvestimentos' },
    });

  if (isMobile) {
    return (
      <HStack alignItems="center" justifyContent={'space-between'}>
        <Button
          p={0}
          mx="inline.xxs"
          testID="return-button"
          size="lg"
          variant="textLink"
          leftIcon={<UI.Icon name="ArrowLeft" size="xxs" color={Color['neutral.black']} />}
          justifyContent="start"
          onPress={onReturn}
          _text={{
            color: Color['neutral.black'],
            textTransform: 'initial',
            pl: Spacing['inline.nano'],
            fontSize: Typography['fontsize.lg'],
          }}>
          Produtos disponíveis
        </Button>
        <VisitLegacyPage onPress={onAvailableProductsLegacyPress} />
      </HStack>
    );
  }

  return (
    <HStack alignItems="center" justifyContent="space-between" w="full">
      <HStack alignItems="center" space="inline.xxxs">
        <UI.IconButton
          icon="ArrowLeft"
          testId="return-button"
          iconColor={Color['brand.tertiary.principal']}
          iconSize="xs"
          shadow={3}
          variant="link"
          onPress={onReturn}
        />
        <UI.Heading testId="qa" size="h2">
          Produtos disponíveis
        </UI.Heading>
      </HStack>
      <VisitLegacyPage onPress={onAvailableProductsLegacyPress} />
    </HStack>
  );
};
